import {getRightPrice, isDesktop, isMobile, numberFormat, scale} from "../helpers";

export function initCustomShirtComponent(){
    const $customShirtFamily = $('[data-custom-shirt-family]');
    const $customShirtNumber = $('[data-custom-shirt-number]');
    const $productPrice = $('[data-product-price]');

    initCustomShirtHandlers();

    //костыль на главную страницу (выбираем сразу размер)
    if($('#main_page_landing').length){
        //первый доступный размер
        const $firstSize =  $('.switcher.custom-shirt-size:not(.disabled)').first();
        const priceSize = $firstSize.data('price');
        $productPrice.data('product-price', priceSize);
        $productPrice.text(`${numberFormat(priceSize, 0, '', ' ')} ₽`);
        $firstSize.addClass('chosen');

    }

    function initCustomShirtHandlers() {
        //раскрытие выпадающего списка с чекбоксами
        $('[data-checkboxes-trigger]').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $currentTarget = $(e.target);

            if (!$currentTarget.hasClass('custom-shirts-checkboxes') && !$currentTarget.hasClass('custom-checkbox-label')) {
                if ($(this).hasClass('opened')) {
                    $(this).removeClass('opened').next().slideToggle({duration: 150});

                } else {
                    $(this).addClass('opened').next().slideToggle({duration: 150});
                }
            }
        });

        //переключение размеров кастомной майки
        $('.switcher.custom-shirt-size').add('.switcher.custom-shirt-page').on('click', function(e) {
            const $clickedSize = $(e.currentTarget);
            if($clickedSize.hasClass('chosen')) return;
            let clickedSizePrice = $(e.currentTarget).data('price');
            let oldSizePrice = $clickedSize.siblings('.switcher.custom-shirt-size.chosen').data('price');
            let newProductPrice = clickedSizePrice - oldSizePrice;
            let $noSizeText = $clickedSize.parent().parent().find('[data-no-sizes-chosen]');
            let currentProductPrice = +$productPrice.data('product-price');

            //если страница товара с кастомной майкой
            if($('#product_page_landing').length) {
                //если предыдущий был со скидкой
                if($clickedSize.siblings('.switcher.custom-shirt-page.chosen').data('sale-price') && +$clickedSize.siblings('.switcher.custom-shirt-page.chosen').data('sale-price') !== 0){
                    oldSizePrice = $clickedSize.siblings('.switcher.custom-shirt-page.chosen').data('sale-price') || +$productPrice.data('product-price');

                }else{
                    oldSizePrice = $clickedSize.siblings('.switcher.custom-shirt-page.chosen').data('price') || +$productPrice.data('product-price');
                }


                //если клик по размеру со скидкой
                if($clickedSize.data('sale-price') && +$clickedSize.data('sale-price') !== 0){
                    clickedSizePrice = $(e.currentTarget).data('sale-price');
                    $('[data-product-without-sale-price-text]').removeClass('hide');
                    $('[data-product-without-sale-price-text]').text(`${numberFormat($(e.currentTarget).data('price'), 0, '', ' ')} ₽`);

                }else{
                    $('[data-product-without-sale-price-text]').addClass('hide');
                }

                $noSizeText = $clickedSize.parent().find('[data-no-sizes-chosen]');
                currentProductPrice = +$productPrice.data('product-price');
                newProductPrice = clickedSizePrice - oldSizePrice;

            }

            $productPrice.data('product-price', newProductPrice + currentProductPrice);
            $productPrice.text(`${numberFormat(newProductPrice + currentProductPrice, 0, '', ' ')} ₽`);

            if(!$clickedSize.hasClass('chosen')){
                $clickedSize.addClass('chosen').siblings('.switcher:not(.disabled)').removeClass('chosen');
                $noSizeText.css('opacity', 0);

            }

            if(!$clickedSize.hasClass('custom-shirt-size')){
                $('.inputs-wrapper').find('[data-no-sizes-chosen]').css('opacity', 0)
            }
        });

        //чекбоксы
        $('.custom-checkbox-label').on('click', e => {
            e.preventDefault();
            const $clickedLabel = $(e.currentTarget);
            const $input = $clickedLabel.find('input');
            const checkboxPrice = +$clickedLabel.data('logo-price');
            const currentProductPrice = +$productPrice.data('product-price');
            const $logosFullPrice = $('[data-logos-price]');
            const $logosShirtPrice = $('[data-logos-shirt-price]');

            if ($input.prop('checked')) {
                const newProductPrice = currentProductPrice - checkboxPrice;
                $input.prop('checked', false);
                $clickedLabel.removeClass('checked');
                $productPrice.data('product-price', newProductPrice);
                $productPrice.text(`${numberFormat(newProductPrice, 0, '', ' ')} ₽`);


                if(!$('.custom-shirts-checkboxes').find('input:checked').length){
                    $logosFullPrice.removeClass('showed');
                    $logosFullPrice.data('logos-price', 0);

                }else{
                    const currentLogosPrice = +$logosFullPrice.data('logos-price');
                    $logosFullPrice.data('logos-price', currentLogosPrice - checkboxPrice);
                    $logosFullPrice.text(`+ ${numberFormat(+$logosFullPrice.data('logos-price'), 0, '', ' ')} ₽`);
                    $logosFullPrice.addClass('showed');
                }

            } else {
                const newProductPrice = currentProductPrice + checkboxPrice;
                $input.prop('checked', true);
                $clickedLabel.addClass('checked');
                $productPrice.data('product-price', newProductPrice);
                $productPrice.text(`${numberFormat(newProductPrice, 0, '', ' ')} ₽`);

                if(!$('.custom-shirts-checkboxes').find('input:checked').length){
                    $logosFullPrice.removeClass('showed');
                    $logosFullPrice.data('logos-price', 0);

                }else{
                    const currentLogosPrice = +$logosFullPrice.data('logos-price');
                    $logosFullPrice.data('logos-price', currentLogosPrice + checkboxPrice);
                    $logosFullPrice.text(`+ ${numberFormat(+$logosFullPrice.data('logos-price'), 0, '', ' ')} ₽`);
                    $logosFullPrice.addClass('showed');
                }
            }

            if(!$('.custom-checkbox-label.blue-checkbox').find('input:checked').length){
                $logosShirtPrice.removeClass('showed');
            }else{
                $logosShirtPrice.addClass('showed');
            }
        });

        //чекбокс на кастомной майке
        $('#additional_options_label').on('click', function () {
            const isChecked = $(this).find('input').prop('checked');

            if(!isChecked){
                $('[data-no-logo-chosen-fio]').css('display', 'none');
                $('[data-no-logo-chosen-number]').css('display', 'none');

            }else{
                if($('#custom_shirt_family').val() === ''){
                    $('[data-no-logo-chosen-fio]').css('display', 'block');
                }

                if($('#custom_shirt_number').val() === ''){
                    $('[data-no-logo-chosen-number]').css('display', 'block');
                }
            }
        });

        //вывод фамилии на кастомную майку
        $('#custom_shirt_family').on('input', function () {
            let familyValue = $(this).val();

            if (this.value.length > 16) {
                this.value = this.value.slice(0,16);
                familyValue = this.value;
            }

            changeProductPrice(this);

            if (familyValue === '') {
                if (isDesktop()) {
                    $customShirtFamily.css('font-size', '3.1vw');

                } else if (isMobile()) {
                    $customShirtFamily.css('font-size', '7vw');
                }

                if($('#additional_options_label').find('input').prop('checked')){
                    $('[data-no-logo-chosen-fio]').css('display', 'block');
                }

            }else{
                $('[data-no-logo-chosen-fio]').css('display', 'none');
            }

            $customShirtFamily.text(familyValue);
            scale($customShirtFamily[0]);
        });

        //вывод номера на кастомную майку
        $('#custom_shirt_number').on('input', function () {
            let numberValue = $(this).val();
            if (this.value.length > 2) {
                this.value = this.value.slice(0,2);
                numberValue = this.value;
            }

            changeProductPrice(this);

            if ($(this).val() !== '') {
                $(this).siblings('.input-price').addClass('showed');
                $('[data-no-logo-chosen-number]').css('display', 'none');

            } else {
                $(this).siblings('.input-price').removeClass('showed');

                if($('#additional_options_label').find('input').prop('checked')){
                    $('[data-no-logo-chosen-number]').css('display', 'block');
                }
            }

            if (numberValue === '') {
                if (isDesktop()) {
                    $customShirtNumber.css('font-size', '12.6vw');

                } else if (isMobile()) {
                    $customShirtNumber.css('font-size', '30vw');
                }
            }

            $customShirtNumber.text(numberValue);
            scale($customShirtNumber[0]);
        });

        function changeProductPrice(input) {
            const currentProductPrice = +$productPrice.data('product-price');
            const inputPrice = +$(input).siblings('.input-price').data('input-price');

            if ($(input).val() !== '' && !$(input).siblings('.input-price').hasClass('showed')) {
                const newProductPrice = currentProductPrice + inputPrice;
                $(input).siblings('.input-price').addClass('showed');
                $productPrice.data('product-price', newProductPrice);
                $productPrice.text(`${numberFormat(newProductPrice, 0, '', ' ')} ₽`);


            } else if ($(input).val() === '' && $(input).siblings('.input-price').hasClass('showed')) {
                const newProductPrice = currentProductPrice - inputPrice;
                $(input).siblings('.input-price').removeClass('showed');
                $productPrice.data('product-price', newProductPrice);
                $productPrice.text(`${numberFormat(newProductPrice, 0, '', ' ')} ₽`);

            }
        }
    }
}